import React, { Component } from 'react'
import _ from 'lodash'

import { updateModuleData } from 'helpers/specHelpers'
import ListSpec from 'containers/Project/ListSpec/index'
import { SPEC_ORDER } from 'containers/Project/Specifications/constants'
import CommonSpec from 'containers/Project/CommonSpec/index'

class PowerMonitorIcSpec extends Component {
  render() {
    const {
      moduleData,
      isModifiedPage,
      curFilter,
      ModuleHeader,
    } = this.props
    
    const powerMonitorIcData = moduleData['power_monitor_ic']
    if(!powerMonitorIcData) return null

    const newModuleData = _.cloneDeep(powerMonitorIcData)
    return (
      <ListSpec
        moduleName='power_monitor_ic'
        moduleData={ newModuleData }
        isModifiedPage={ isModifiedPage }
        curFilter={curFilter}
        ModuleHeader={ModuleHeader}
      />
    )
  }
}

export default PowerMonitorIcSpec
